module.exports = require("@mui/icons-material/WatchLaterSharp");